import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-internal-surface',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './internal-surface.component.html',
  styleUrl: './internal-surface.component.scss'
})
export class InternalSurfaceComponent {

}
